import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase'

const InsuranceIcon = ({
  strokeWidth = 1,
  fill = 'transparent',
  color = 'icon.primary',
  ...props
}) => {
  return (
    <IconBase viewBox='0 0 17 19' {...props}>
      <Path
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={strokeWidth}
        fill={fill}
        d='M16 8.532c0 4.379-3.2 8.474-7.5 9.468C4.2 17.006 1 12.91
         1 8.532v-3.44c0-.783.46-1.49 1.165-1.785l4.688-1.974a4.235
          4.235 0 0 1 3.294 0l4.688 1.974A1.93 1.93 0 0 1 16 5.092v3.44Z'
        clipRule='evenodd'
      />
      <Path
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={strokeWidth}
        fill={fill}
        d='m12.007 7.172-3.67 3.669-2.2-2.202'
      />
    </IconBase>
  )
}

InsuranceIcon.propTypes = {
  strokeWidth: PropTypes.number,
  fill: PropTypes.string,
  color: PropTypes.string,
}

export default InsuranceIcon
